// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.me-3.mb-4.rev-padd-tap.doct-view 
{
    background: #fff;
    border: 1px solid #dfdfdf;
    border: 1px solid var(--light-gray-outline, #dfdfdf);
    border-radius: 10px;
   /* padding: 40px 35px 35px 35px;*/
    position: absolute;
    top: 60px;
    padding: 7mm;
    left: 1%;
    right: 0%;
    min-height: 100px;
    width: 100%;
    max-width: 98%;

  }

    .form-floating.wraper.minH.mb-3.over-ride.dowmloads {
        left: 0px;
    }
 

.btnAlg_same.divz-width {
    width: 100%;
    word-break: break-all;
}

.f-name
    { color: var(--Avenu-Black, #302b3a) !important;
    font-family: Manrope, sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
.sub-name
{       color: var(--gray-accessible-text, #666);
        font-family: Manrope, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .inptFiles_up.aligDivs_rev.downz {
        margin: 0px 0px 0px -109px !important;
    }

    .print-pdf{
        background: var(--color1);
        color: #fff;
          /* margin: 12px 9px 0px 0px !important; */
    border: none;
    border-radius: 7px;
    float: right;
    width: 100%;
    height: 40px;
    background: var(--color1);
    color: #fff;
    max-width: 110px;
    position: relative;
    right: 18px;
    top: 10px;
       
    }




@media (min-width:320px){ 


}


@media (min-width:480px)  {  
    

}
@media (min-width:600px)  { }
@media (min-width:801px)  {  }
@media (min-width:1025px) { }`, "",{"version":3,"sources":["webpack://./src/assets/css/download.css"],"names":[],"mappings":";AACA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,oDAAoD;IACpD,mBAAmB;GACpB,iCAAiC;IAChC,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,cAAc;;EAEhB;;IAEE;QACI,SAAS;IACb;;;AAGJ;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;MACM,6CAA6C;IAC/C,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;QACQ,wCAAwC;QACxC,gCAAgC;QAChC,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,qCAAqC;IACzC;;IAEA;QACI,yBAAyB;QACzB,WAAW;UACT,yCAAyC;IAC/C,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,SAAS;;IAET;;;;;AAKJ;;;AAGA;;;AAGA;;;AAGA;AACA,4BAA4B;AAC5B,6BAA6B;AAC7B,4BAA4B","sourcesContent":["\n.me-3.mb-4.rev-padd-tap.doct-view \n{\n    background: #fff;\n    border: 1px solid #dfdfdf;\n    border: 1px solid var(--light-gray-outline, #dfdfdf);\n    border-radius: 10px;\n   /* padding: 40px 35px 35px 35px;*/\n    position: absolute;\n    top: 60px;\n    padding: 7mm;\n    left: 1%;\n    right: 0%;\n    min-height: 100px;\n    width: 100%;\n    max-width: 98%;\n\n  }\n\n    .form-floating.wraper.minH.mb-3.over-ride.dowmloads {\n        left: 0px;\n    }\n \n\n.btnAlg_same.divz-width {\n    width: 100%;\n    word-break: break-all;\n}\n\n.f-name\n    { color: var(--Avenu-Black, #302b3a) !important;\n    font-family: Manrope, sans-serif;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n}\n.sub-name\n{       color: var(--gray-accessible-text, #666);\n        font-family: Manrope, sans-serif;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n    }\n    .inptFiles_up.aligDivs_rev.downz {\n        margin: 0px 0px 0px -109px !important;\n    }\n\n    .print-pdf{\n        background: var(--color1);\n        color: #fff;\n          /* margin: 12px 9px 0px 0px !important; */\n    border: none;\n    border-radius: 7px;\n    float: right;\n    width: 100%;\n    height: 40px;\n    background: var(--color1);\n    color: #fff;\n    max-width: 110px;\n    position: relative;\n    right: 18px;\n    top: 10px;\n       \n    }\n\n\n\n\n@media (min-width:320px){ \n\n\n}\n\n\n@media (min-width:480px)  {  \n    \n\n}\n@media (min-width:600px)  { }\n@media (min-width:801px)  {  }\n@media (min-width:1025px) { }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
